import React from 'react'
import './Contato.css'

const Contato = () => {
  return (
    <main className="contatoPage">
      <div className="contatoContent">
        <section className="contatoIntro">
          <span>Contato</span>
          <h1>Fale com a ASJF</h1>
          <p>
            Se você deseja entrar em contato com a ASJF, estamos prontos para ajudar.
            Envie sua mensagem, sugestão ou solicitação e nossa equipe retornará o contato o mais breve possível.
          </p>
        </section>

        <div className="contatoGrid">
          <section className="contatoCard">
            <h2>Nossos canais</h2>
            <ul className="contatoList">
              <li>
                <strong>Telefone</strong>
                <span>
                  <a
                    href="https://wa.me/553298179934?text=Olá%20ASJF%2C%20gostaria%20de%20entrar%20em%20contato%20com%20a%20associação."
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    (32) 9817-9934
                  </a>
                </span>
              </li>
              <li>
                <strong>Email</strong>
                <span>asjf.jf1992@gmail.com</span>
              </li>
              <li>
                <strong>Endereço</strong>
                <span> Rua Mister Moore, nº 157, sala 105, no Centro de Juiz de Fora.</span>
              </li>
              <li>
                <strong>Horário</strong>
                <span>Breve</span>
              </li>
            </ul>
          </section>

          <section className="contatoForm">
            <h2>Enviar mensagem</h2>
            <div className="formGroup">
              <label htmlFor="name">Nome</label>
              <input type="text" id="name" placeholder="Seu nome" />
            </div>
            <div className="formGroup">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" placeholder="seu@email.com" />
            </div>
            <div className="formGroup">
              <label htmlFor="message">Mensagem</label>
              <textarea id="message" placeholder="Escreva sua mensagem" />
            </div>
            <button type="button">Enviar mensagem</button>
          </section>
        </div>
      </div>
    </main>
  )
}

export default Contato
